export const Logo = (props) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_180_157)">
        <rect width="32" height="32" rx="10" fill="#4A25D5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9733 24.8C13.7144 24.8 11.4555 23.9395 9.73103 22.2149C6.28381 18.7675 6.28381 13.1788 9.73103 9.73135C13.1782 6.28394 18.7666 6.28394 22.2138 9.73135C25.6611 13.1788 25.6611 18.7675 22.2138 22.2149C22.0327 22.396 21.8443 22.5681 21.6505 22.7312L15.9715 27.9467V24.8H15.9733ZM15.9733 27.9467C18.7231 27.9467 21.4711 27.0047 23.6974 25.1224L25.7462 27.1713C25.4328 28.0282 25.6176 29.0282 26.3023 29.7129L31.8853 35.2962C32.8236 36.2346 34.3579 36.2346 35.2962 35.2962C36.2346 34.3578 36.2346 32.8234 35.2962 31.885L29.7133 26.3018C29.0286 25.617 28.0286 25.4322 27.1718 25.7456L25.1231 23.6967C29.1028 18.9921 28.8764 11.9415 24.4401 7.50674C19.7647 2.83109 12.1838 2.83109 7.50655 7.50674C2.83115 12.1824 2.83115 19.7638 7.50655 24.4413C9.84334 26.7782 12.9083 27.9485 15.9733 27.9467Z"
          fill="#B7E801"
          stroke="#B7E801"
          strokeWidth="0.4"
        />
        <path
          d="M14.0891 15.9351C14.0891 14.8305 13.5295 13.9351 12.8391 13.9351C12.1488 13.9351 11.5891 14.8305 11.5891 15.9351"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M20.5891 15.9351C20.5891 14.8305 20.0295 13.9351 19.3391 13.9351C18.6488 13.9351 18.0891 14.8305 18.0891 15.9351"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_180_157">
          <rect width="32" height="32" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
